import React from 'react';
import Typography from '@mui/material/Typography';
import NumberFormat from 'react-number-format';

const fontSizes = { xs: 16, sm: 20, md: 24 };

const FunFact = ({
  correctAnswer,
  fact,
}: {
  correctAnswer: number;
  fact: string;
}) => {
  const factPieces = fact.includes('{correct}')
    ? fact.split('{correct}')
    : [fact];

  return (
    <Typography
      align="center"
      color="text.secondary"
      fontSize={fontSizes}
      mb={4}
    >
      {factPieces.length < 2 ? (
        <>{factPieces[0]}</>
      ) : (
        <>
          {factPieces[0]}
          <Typography
            component="span"
            color="white"
            fontSize={fontSizes}
          >
            <NumberFormat
              value={correctAnswer}
              displayType={'text'}
              thousandSeparator={' '}
            />
          </Typography>
          {factPieces[1]}
        </>
      )}
    </Typography>
  );
};

export { FunFact };
